import { createSelector } from 'reselect'

export const getProfileUpdateError = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.error ? state.user.profile.error : null,
  error => error
)
